export default __webpack_public_path__ + "static/almondjamun-e192c74f2abfed4d7cd5e2fda70fe934.png";